// extracted by mini-css-extract-plugin
export var modal = "_g1-0";